import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const foodApi = createApi({
  reducerPath: 'food',
  tagTypes: ['Food'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchFoods: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Food', id: 'LIST' },
                ...result.map((r) => ({ type: 'Food', id: r.id })),
              ]
            : [{ type: 'Food', id: 'LIST' }],
        query: () => ({
          url: '?resource=food&order=created_at.asc',
          method: 'GET',
        }),
      }),

      createFood: builder.mutation({
        invalidatesTags: [{ type: 'Food', id: 'LIST' }],
        query: (data) => ({
          url: '?resource=food',
          method: 'POST',
          body: data,
        }),
      }),

      updateFood: builder.mutation({
        invalidatesTags: (result, error, { id: foodId }) => [
          { type: 'Food', id: foodId },
          { type: 'Food', id: 'LIST' },
        ],
        query: ({ id: foodId, submitData }) => ({
          url: `?resource=food&id=eq.${foodId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),

      fetchFood: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Food', id: arg }],
        query: (foodId) => ({
          url: `?resource=food&id=eq.${foodId}`,
          method: 'GET',
        }),
      }),

      deleteFood: builder.mutation({
        // Corregido: el tag original era 'Program' por error; debe ser 'Food'
        invalidatesTags: (result, error, foodId) => [
          { type: 'Food', id: foodId },
          { type: 'Food', id: 'LIST' },
        ],
        query: (foodId) => ({
          url: `?resource=food&id=eq.${foodId}`,
          method: 'DELETE',
        }),
      }),
    };
  },
});

export const {
  useFetchFoodsQuery,
  useCreateFoodMutation,
  useUpdateFoodMutation,
  useFetchFoodQuery,
  useDeleteFoodMutation,
} = foodApi;

export { foodApi };
